import React from "react"
import PropTypes from "prop-types"
import MasterArea from "./MasterArea"

const MasterAreas = ({ layoutId, mLocIds, activeOverlay, filter }) => {
	const masterAreas = []
	for (let i = 0; i < mLocIds.length; i++) {
		const mLocId = mLocIds[i]
		masterAreas.push(
			<MasterArea key={mLocId} mLocId={mLocId} layoutId={layoutId} activeOverlay={activeOverlay} filter={filter} />,
		)
	}
	return masterAreas
}

MasterAreas.propTypes = {
	mLocIds: PropTypes.array.isRequired,
}

export default MasterAreas
